import { ReactNode, FC, memo } from "react";
import "./modal.scss";
import { Button } from "@components/button";
import { createPortal } from "react-dom";
import { CloseIcon } from "@components/icons";
import { useOutsideClick } from "@hooks/use-outside-click";

type ModalProps = {
  children: ReactNode;
  onClose?: () => void;
  isOpen: boolean;
  placement?: "right" | "center" | "middle";
  closePlacement?: "right" | "left";
  closeIconColor?: "#FFFFFF" | "#00033e";
  closeTop?: string;
  width?: string;
  allowCloseOnOutsideClick?: boolean;
};

const ModalComponent: FC<ModalProps> = ({
  children,
  onClose,
  isOpen,
  placement,
  closePlacement = "right",
  closeIconColor = "#00033e",
  closeTop,
  width,
  allowCloseOnOutsideClick = false,
}) => {
  const container = document.querySelector("#ul-modal");

  const ref = useOutsideClick<HTMLDivElement>(() => {
    if (allowCloseOnOutsideClick && isOpen && onClose) {
      onClose();
    }
  });

  if (!isOpen || !container) {
    return null;
  }
  return createPortal(
    <>
      <button className="modal-mask" />
      <div className={`modal-container ${placement}`}>
        <div ref={ref} className="modal-wrapper" style={{ width }}>
          {onClose ? (
            <Button
              onClick={onClose}
              className={`close ${closePlacement}`}
              variant="close"
              style={{ top: closeTop }}
            >
              <CloseIcon color={closeIconColor} size={16} />
            </Button>
          ) : null}
          {children}
        </div>
      </div>
    </>,
    container,
  );
};

export const Modal = memo(ModalComponent);
